import { render } from "./ChooseDeliveryMethodContainer.vue?vue&type=template&id=8c52507e"
import script from "./ChooseDeliveryMethodContainer.vue?vue&type=script&lang=js"
export * from "./ChooseDeliveryMethodContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__